<template>
  <div class="activity-info app-region blank-t-v blank-b-v blank-l-h blank-r-h" v-if="!isScan">
    <a-steps :current="currentStep">
      <a-step>
        <template slot="title">活动信息</template>
      </a-step>
      <a-step>
        <template slot="title">报名表单</template>
      </a-step>
    </a-steps>
    <a-form-model class="app-form" ref="form" :rules="rules" :model="form" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol" v-show="currentStep === 0">
      <a-form-model-item label="活动名称" prop="title">
        <a-input v-model="form.title" placeholder="请输入活动名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="活动起止时间" prop="time">
        <a-range-picker v-model="form.time" show-time valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
      </a-form-model-item>
      <a-form-model-item label="活动封面" prop="avatar">
        <a-upload name="media" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange" preview>
          <dy-image :src="form.avatar" v-if="form.avatar"></dy-image>
          <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="发布社区" prop="community">
        <a-select mode="multiple" v-model="form.community" placeholder="请选择发布社区" :disabled="!!id || !isPlatformRole">
          <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="消息推送状态" prop="push">
        <a-radio-group v-model="form.push">
          <a-radio :value="1">推送</a-radio>
          <a-radio :value="0">不推送</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="积分数额" prop="score">
        <a-input-number v-model="form.score" placeholder="请输入奖励积分数额" :min="0"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="活动地点" prop="address">
        <a-input v-model="form.address" placeholder="请输入活动地点" :min="0"></a-input>
      </a-form-model-item>
      <a-form-model-item label="活动名额" prop="number">
        <a-input-number v-model="form.number" placeholder="请输入活动名额限制" :min="0"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="报名结束时间" prop="endTime">
        <a-date-picker v-model="form.endTime" placeholder="请选择报名结束时间" show-time valueFormat="YYYY-MM-DD HH:mm:ss"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="活动介绍" prop="note">
        <editor name="editor" v-model="form.note"></editor>
      </a-form-model-item>
      <a-form-model-item label="活动简介" prop="content">
        <a-textarea v-model="form.content" placeholder="请输入活动简介"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="currentStep = 1">下一步</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <template v-if="currentStep === 1">
      <a-row type="flex" :gutter="[32, 32]">
        <a-col>
          <a-space direction="vertical" class="bar">
            <p>自定义栏位</p>
            <a-button block @click="addField('text', '单行文本框')">单行文本框</a-button>
            <a-button block @click="addField('textarea', '多行文本框')">多行文本框</a-button>
            <a-button block @click="addField('radio', '单选按钮')">单选按钮</a-button>
            <a-button block @click="addField('checkbox', '多选按钮')">多选按钮</a-button>
            <a-button block @click="addField('number', '数字输入框')">数字输入框</a-button>
            <a-button block @click="addField('date', '日期选择框')">日期选择框</a-button>
            <a-button block @click="addField('select', '下拉列表')">下拉列表</a-button>
          </a-space>
        </a-col>
        <a-col flex="1">
          <a-row :gutter="[0, 32]" type="flex" v-for="(value, index) in form.fields" :key="index">
            <a-col>
              <a-checkbox class="app-text" :checked="!!value.required" :disabled="index === 0 || index === 1" @change="changeRequired(value)">必填</a-checkbox>
            </a-col>
            <a-col flex="1">
              <a-row :gutter="[0, 8]">
                <a-col>
                  <a-space>
                    <a-input v-model="value.name" :disabled="index === 0 || index === 1" allow-clear></a-input>
                    <a-input v-model="value.placeholder" allow-clear></a-input>
                    <a-icon type="close" @click="delField(index)" v-if="index !== 0 && index !== 1"></a-icon>
                  </a-space>
                </a-col>
                <a-col v-if="value.options">
                  <a-row :gutter="[8, 8]" type="flex" align="middle">
                    <a-col class="field-option" v-for="(m, n) in value.options" :key="n">
                      <a-input v-model="value.options[n]" allow-clear></a-input>
                      <a-icon type="close-circle" @click="delFieldOption(value, n)"></a-icon>
                    </a-col>
                    <a-col>
                      <a-icon type="plus" @click="addFieldOption(value)"></a-icon>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-space class="bottom-btns">
        <a-button type="primary" @click="currentStep = 0">上一步</a-button>
        <a-button type="primary" @click="submit">确定</a-button>
        <a-button @click="cancel">取消</a-button>
      </a-space>
    </template>
  </div>
  <div class="activity-info" v-else>
    <a-descriptions title="活动信息" bordered v-viewer>
      <a-descriptions-item label="活动名称">{{form.title}}</a-descriptions-item>
      <a-descriptions-item label="活动起止时间">{{form.time.join('-')}}</a-descriptions-item>
      <a-descriptions-item label="活动封面">
        <dy-image :src="form.avatar"></dy-image>
      </a-descriptions-item>
      <a-descriptions-item label="发布社区">{{communityOptions.filter(val => form.community.indexOf(val.id) > -1).map(val => val.name).join('、')}}</a-descriptions-item>
      <a-descriptions-item label="消息推送状态">{{form.push ? '推送' : '不推送'}}</a-descriptions-item>
      <a-descriptions-item label="积分数额">{{form.score}}</a-descriptions-item>
      <a-descriptions-item label="活动名额">{{form.number}}</a-descriptions-item>
      <a-descriptions-item label="报名结束时间" :span="2">{{form.endTime}}</a-descriptions-item>
      <a-descriptions-item label="活动介绍" :span="3"><span v-html="form.note"></span></a-descriptions-item>
      <a-descriptions-item label="活动简介" :span="3">{{form.content}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="报名表单">
      <a-descriptions-item>
        <a-row :gutter="[0, 32]" type="flex" v-for="(value, index) in form.fields" :key="index">
          <a-col>
            <a-checkbox class="app-text" :checked="!!value.required" disabled>必填</a-checkbox>
          </a-col>
          <a-col flex="1">
            <a-row :gutter="[0, 8]">
              <a-col>
                <a-space>
                  <a-input v-model="value.name" disabled></a-input>
                  <a-input v-model="value.placeholder" disabled></a-input>
                </a-space>
              </a-col>
              <a-col v-if="value.options">
                <a-row :gutter="[8, 8]" type="flex" align="middle">
                  <a-col class="field-option" v-for="(m, n) in value.options" :key="n">
                    <a-input v-model="value.options[n]" disabled></a-input>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
  import CommunityService from '@/io/community.js';
  import ActivityService from '@/io/activity.js';

  export default {
    name: 'ActivityInfo',
    props: {
      isScan: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        default() {
          return this.$route.params.id * 1;
        }
      }
    },
    data() {
      return {
        currentStep: 0,
        avatar: {
          loading: false,
        },
        communityOptions: [],
        form: {
          title: null,
          time: [],
          avatar: null,
          community: [],
          push: null,
          score: null,
          address: null,
          number: null,
          endTime: null,
          note: null,
          content: null,
          fields: [
            {
              id: null,
              type: 'input',
              name: '用户名',
              ename: 'username',
              placeholder: '请输入用户名',
              required: 1,
              is_default: 1,
              options: null,
              extends: null
            },
            {
              id: null,
              type: 'tel',
              name: '手机号',
              ename: 'mobile',
              placeholder: '请输入手机号码',
              required: 1,
              is_default: 1,
              options: null,
              extends: null
            }
          ]
        },
        rules: {
          title: [
            {
              required: true,
              message: "请输入活动名称",
            },
          ],
          time: [
            {
              required: true,
              message: "请选择活动起止时间",
            },
          ],
          avatar: [
            {
              required: true,
              message: "请上传活动封面",
            },
          ],
          community: [
            {
              required: true,
              message: "请选择发布社区",
            },
          ],
          push: [
            {
              required: true,
              message: "请选择消息推送状态",
            },
          ],
          score: [
            {
              required: true,
              message: "请输入积分数额",
            },
          ],
          address: [
            {
              required: true,
              message: "请输入活动地点",
            },
          ],
          number: [
            {
              required: true,
              message: "请输入活动名额",
            },
          ],
          endTime: [
            {
              required: true,
              message: "请选择报名结束时间",
            },
          ],
          note: [
            {
              required: true,
              message: "请输入活动介绍",
            },
          ]
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initCommunity().then(() => {
            this.initPage();
          });
        },
        immediate: true,
      },
    },
    methods: {
      initPage() {
        if (this.$getCookie('communityId')) {
          this.form.community = [this.$getCookie('communityId') * 1];
        }
        if (this.id) {
          ActivityService.info(this.id).then(res => {
            this.form.title = res.title;
            this.form.time = [res.start_time, res.end_time];
            this.form.avatar = res.banner;
            this.form.community = res.community_ids;
            this.form.push = res.status;
            this.form.score = res.score;
            this.form.address = res.address;
            this.form.number = res.places;
            this.form.endTime = res.signup_end_time;
            this.form.note = res.content;
            this.form.content = res.desc;
            this.form.fields = res.fields;
          }).catch(err => {});
        }
      },
      getRandomString(len) {
        len = len || 10;
        let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        let maxPos = $chars.length;
        let pwd = '';
        for (var i = 0; i < len; i++) {
          pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
        }
        return pwd;
      },
      addField(type, name) {
        let options = null;
        if (type === 'radio' || type === 'checkbox' || type === 'select') {
          options = ['选项1', '选项2'];
        }
        this.form.fields.push({
          id: null,
          type,
          name,
          ename: `${type}_${this.getRandomString()}`,
          placeholder: '请输入',
          required: 0,
          is_default: 0,
          options,
          extends: null,
          enable: 1
        });
      },
      delField(index) {
        this.form.fields.splice(index, 1);
      },
      addFieldOption(data) {
        data.options.push('选项');
      },
      delFieldOption(data, index) {
        data.options.splice(index, 1);
      },
      changeRequired(data) {
        data.required = data.required === 1 ? 0 : 1;
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      handleChange(info) {
        let status = info.file.status;
        if (status) {
          if (status === 'done') {
            this.avatar.loading = false;
            this.form.avatar = info.file.response.media;
          } else {
            this.avatar.loading = true;
          }
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            ActivityService.edit(
              this.id,
              this.form.title,
              this.form.time[0],
              this.form.time[1],
              this.form.avatar,
              this.form.community,
              this.form.push,
              this.form.score,
              this.form.address,
              this.form.number,
              this.form.endTime,
              this.form.note,
              this.form.content,
              this.form.fields
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            ActivityService.add(
              this.form.title,
              this.form.time[0],
              this.form.time[1],
              this.form.avatar,
              this.form.community,
              this.form.push,
              this.form.score,
              this.form.address,
              this.form.number,
              this.form.endTime,
              this.form.note,
              this.form.content,
              this.form.fields
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        }, () => {
          this.currentStep = 0;
        });
      },
      cancel() {
        this.$router.push({
          name: 'CommunityActivity'
        });
      },
    }
  }
  </script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .ant-steps {
    width: 30%;
    margin: 0 auto @padding-lg auto;
  }
  .bar {
    text-align: center;
  }
  .field-option {
    position: relative;
    .anticon {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .bottom-btns {
    width: 100%;
    justify-content: center;
    margin-top: @padding-lg;
  }
</style>